import { onActivated, onMounted, onBeforeUnmount, type Ref } from 'vue';

type ScrollPos = { top: number; left: number };

export function useKeepAliveScroll(rootRef: Ref<HTMLElement | null>) {
  const positions = new Map<Element, ScrollPos>();

  function onScrollCapture(event: Event) {
    const el = event.target;
    if (el instanceof HTMLElement) {
      positions.set(el, { top: el.scrollTop, left: el.scrollLeft });
    }
  }

  function restore() {
    positions.forEach((pos, el) => {
      if (el.isConnected) {
        el.scrollTop = pos.top;
        el.scrollLeft = pos.left;
      }
    });
  }

  onMounted(() => {
    rootRef.value?.addEventListener('scroll', onScrollCapture, {
      capture: true,
      passive: true,
    });
  });

  onBeforeUnmount(() => {
    rootRef.value?.removeEventListener('scroll', onScrollCapture, {
      capture: true,
    });
  });

  onActivated(() => {
    restore();
    requestAnimationFrame(restore);
  });
}
